export default [
  {
    name: "",
    button: "Line",
    required: false,
    field_id: "single_line",
    value: null,
    label: "Short Line",
    klass: null,
    help_text: "",
    validate_text: "--",
    validate: "",
    placeholder: "",
    display_in_builder: true,
    tooltip_text: "A simple question that requires a one line response."
  },
  {
    name: "",
    button: "Multi Line",
    required: false,
    field_id: "multi_line",
    value: null,
    label: "Paragraph",
    klass: null,
    help_text: "",
    validate_text: "--",
    validate: "",
    placeholder: "",
    display_in_builder: true,
    tooltip_text:
      "A question that may require multiple lines to respond,<br> such as an address or a list."
  },
  {
    button: "Multiple choice",
    choices: [
      {
        label: "Option 1",
        value: "option-1"
      },
      { label: "Option 2", value: "option-2" },
      { label: "Option 3", value: "option-3" }
    ],
    display_in_builder: true,
    field_id: "choice",
    help_text: "",
    klass: null,
    label: "Multiple Choice",
    name: "",
    placeholder: "",
    required: false,
    tooltip_text:
      "Radio buttons: When you want the applicant to choose from one of a few options (2 - 5), such as yes/no or true/false",
    validate: null,
    value: null
  },
  {
    button: "Checkboxes",
    choices: [
      {
        label: "Option 1",
        value: "option-1"
      },
      { label: "Option 2", value: "option-2" },
      { label: "Option 3", value: "option-3" }
    ],
    display_in_builder: true,
    field_id: "checkbox",
    help_text: "",
    klass: null,
    label: "Checkboxes",
    name: "",
    placeholder: "",
    required: false,
    tooltip_text: "Checkbox: Allow a user to select 0, 1, or more options from a list.",
    validate: null,
    value: null
  },
  {
    button: "Dropdown",
    choices: [
      {
        label: "Option 1",
        value: "option-1"
      },
      { label: "Option 2", value: "option-2" },
      { label: "Option 3", value: "option-3" }
    ],
    display_in_builder: true,
    field_id: "dropdown",
    help_text: "",
    klass: null,
    label: "Dropdown",
    name: "",
    placeholder: "",
    required: false,
    tooltip_text:
      "A dropdown menu: Good for applicants to select one option from a long list, typically more than 6 choices.",
    validate: null,
    value: null
  },
  {
    name: "",
    button: "File",
    required: false,
    field_id: "file",
    value: null,
    label: "File",
    klass: null,
    help_text: "",
    validate_text: "--",
    validate: "",
    placeholder: "",
    display_in_builder: true,
    tooltip_text: "A file attachment or photo."
  },
  {
    name: "",
    button: "SSN",
    required: false,
    field_id: "ssn",
    value: null,
    label: "Social Security",
    klass: null,
    help_text: "",
    validate: "ssn",
    placeholder: "",
    display_in_builder: true,
    tooltip_text: "Require a valid US social security number."
  },
  {
    name: "",
    button: "Phone",
    required: false,
    field_id: "phone",
    value: null,
    label: "Phone Number",
    klass: null,
    help_text: "",
    validate: "phone",
    placeholder: "(123) 456-7890",
    display_in_builder: true,
    tooltip_text:
      "A US phone number - 7 or 10 digits. Use this field if you want to require a valid phone number."
  },
  {
    name: "",
    button: "Currency",
    required: false,
    field_id: "currency",
    value: null,
    label: "Currency",
    klass: null,
    help_text: "",
    validate: "currency",
    placeholder: "0.00",
    display_in_builder: true,
    tooltip_text: ""
  },
  {
    name: "",
    button: "Date",
    required: false,
    field_id: "date",
    value: null,
    label: "Date",
    klass: null,
    help_text: "",
    validate: "date",
    placeholder: "YYYY-MM-DD",
    display_in_builder: true,
    tooltip_text: "Any date."
  },
  {
    name: "",
    button: "State",
    required: false,
    field_id: "state",
    value: null,
    klass: null,
    help_text: "",
    validate_text: "--",
    validate: "",
    label: "State",
    placeholder: "",
    display_in_builder: false,
    tooltip_text: "A dropdown of the US states and territories."
  },
  {
    name: "",
    button: "Email",
    required: false,
    field_id: "email",
    value: null,
    label: "Email",
    klass: null,
    help_text: "",
    validate: "email",
    placeholder: "name@example.com",
    display_in_builder: true,
    tooltip_text: "Use this field if you want to require a valid email address."
  },
  {
    name: "",
    button: "Text",
    required: false,
    field_id: "text_display",
    value: null,
    label: "Text",
    klass: null,
    help_text: "",
    validate: null,
    placeholder: "",
    display_in_builder: true,
    tooltip_text: ""
  },
  {
    button: "Multi Line",
    display_in_builder: false,
    field_id: "unit_field",
    help_text: "",
    klass: null,
    label: "Unit",
    name: "",
    placeholder: "",
    required: false,
    tooltip_text:
      "A question that may require multiple lines to respond,<br> such as an address or a list.",
    validate: "",
    validate_text: "--",
    value: null
  },
  {
    field_id: "agent",
    button: "Agent Dropdown",
    label: "Agent",
    placeholder: "",
    choices: [],
    display_in_builder: true,
    tooltip_text:
      "A pull down menu list for applicants to choose an agent from within your company.",
    help_text: "",
    name: "",
    validate: "",
    validate_text: "--",
    value: null,
    required: false
  },
  {
    name: "",
    button: "Date",
    required: false,
    field_id: "date_range",
    value: null,
    label: "Date Range",
    klass: null,
    help_text: "",
    validate: null,
    placeholder: "",
    display_in_builder: true
  },
  {
    name: "",
    display_in_builder: true,
    field_id: "address",
    help_text: "",
    klass: null,
    label: "Address",
    placeholder: "",
    required: false,
    tooltip_text:
      "A question that may require multiple lines to respond,<br> such as an address or a list.",
    validate: "",
    validate_text: "--",
    value: null
  },
  {
    button: "Yes or No",
    choices: [
      {
        label: "Yes",
        value: "yes",
        fields: [],
        type: "positive"
      },
      {
        label: "No",
        value: "no",
        fields: [],
        color: "red",
        type: "negative"
      }
    ],
    display_in_builder: true,
    field_id: "yes_no",
    help_text: "",
    klass: null,
    label: "Yes or No",
    name: "",
    placeholder: "",
    required: false,
    tooltip_text: "",
    validate: null,
    value: null
  }
]
